import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';

(($) => {
    // Each wpforms.
    async function handleFormSubmission(event, json) {
        const form = event.target;
        const formId = form.dataset.formid;
        const settings = json.data.formychat || {}

        // Closest .formychat-widget-custom-form of the e.target
        const widget = form.closest('[data-whatsapp]') || null;
        const inputs = Object.fromEntries(settings.fields.map(input => [input.name, input.value]))
    
        
        // Save inputs.
        let data = {
            form: 'wpforms',
            form_id: formId,
            field: Object.fromEntries(settings.fields.map(input => [input.name, input.value])),
            meta: getMeta.value,
            widget_id: widget ? widget.dataset.widget : null,
        }

        if ( widget ) {
            // Inside widget.
            const widgetId = widget.dataset.widget;
            
            if (!widgetId) return;

            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            // Notify parent.
            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin
                    : '*';
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
            } catch (err) {
            }
            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, wpforms_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(wpforms_message_template, inputs);

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }
        } else {
            
            if ( settings.status != 1 ) return;
            let message = getMessage(settings.message, inputs);
            
            const to = settings.destination_type === 'group' && settings.group_invite_code ? settings.group_invite_code : settings.whatsapp_number;
            save(data, to, message, isDesktop(), 1 == settings.new_tab);
            openWhatsapp(to, message, isDesktop(), 1 == settings.new_tab, settings);
        }
    }

    $(document).on('wpformsAjaxSubmitSuccess', handleFormSubmission);
})(jQuery)